<template>
<div id="page-messages" class="container">
    <div class="row">
        <div class="col-xs-12 m-t-4" v-show="!selectedTrack">
            <ul class="page-tabs c2 text-center">
                <li @click="changeTab('#mytracks')" :class="{'active' : isTab('#mytracks')}">My Tracks <span class="unread" v-show="unread.owned_by_me">{{ unread.owned_by_me }}</span></li>
                <li @click="changeTab('#othertracks')" :class="{'active' : isTab('#othertracks')}">Other Tracks <span class="unread" v-show="unread.owned_by_others">{{ unread.owned_by_others }}</span></li>
            </ul>
        </div>

        <div class="col-xs-12 tab-content song-list-container" v-show="!selectedTrack">
        	<song-list v-if="isTabRendered('#mytracks')" v-show="isTab('#mytracks')" :owner="'me'"></song-list>
        	<song-list v-if="isTabRendered('#othertracks')" v-show="isTab('#othertracks')" :owner="'others'"></song-list>
        </div>

        <div class="col-xs-12 tab-content" v-if="selectedTrack">
        	<song-conversations :song="selectedTrack"></song-conversations>
        </div>
    </div>
</div>
</template>

<script>
export default {
    components: {
        'song-list': require('@/components/Messages/SongList.vue').default,
        'song-conversations': require('@/components/Messages/SongConversations.vue').default,
    },

    data() {
        return {
            tab: {
                active:'#mytracks',
                rendered: {
                    '#mytracks': true,
                    '#othertracks': false,
                }
            },

            selectedTrack: false,
            unread:{
            	owned_by_me: 0,
            	owned_by_others: 0,
            	total: 0,
            }
        }
    }, 

    mounted(){
        if (App.allowGtag) gtag('config', 'UA-152097964-2', {
            'page_path' : "/messages",
            'page_location': "/messages",
            'page_title' : "Messages"
        });

		this.$on('song-select', (song) => {
			this.selectedTrack = song;
			$('.ripple').remove();
		})

        this.$root.$on('messages-badges', this.getMessagesBadges);
        this.$root.$emit('messages-badges', {action: 'ask'});
    },

    methods: {
        isTab(tab) {
            return this.tab.active == tab;
        },

        isTabRendered(tab) {
            return this.tab.rendered[tab];
        },

        changeTab(tab) {
            this.tab.active = tab;
            this.tab.rendered[tab] = true;


            if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                'page_path' : "/messages/" + tab.slice(1),
                'page_location': "/messages/" + tab,
                'page_title' : "Messages > " + tab.charAt(1).toUpperCase() + tab.slice(2),
            });              
        },

        getMessagesBadges(params) {
        	if (params.action == 'set'){
        		this.unread = params.value;
        	}
        },

        back(){
            setTimeout(() => {
                if ( this.$router.history.current.name && this.$router.history.current.name != 'home'){
                    this.$router.back();
                }else{
                    this.$router.back();
                    // this.$router.push('/');
                }
            }, 300);
        },
    },

    computed: {
        filters() {
            return {
                'user_id': App.user.id,
                'with_conversation': true,
            }
        },

        hasSongs() {
            return this.songs.length > 0;
        },
    },

    beforeDestroy() {
        this.$root.$off('messages-badges', this.getMessagesBadges);
    } 
}
</script>